import { render, staticRenderFns } from "./w-titleImagebar.vue?vue&type=template&id=458c8916&scoped=true&"
import script from "./w-titleImagebar.vue?vue&type=script&lang=js&"
export * from "./w-titleImagebar.vue?vue&type=script&lang=js&"
import style0 from "./w-titleImagebar.vue?vue&type=style&index=0&id=458c8916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458c8916",
  null
  
)

export default component.exports